export const messagesAnalytics = {
	pageTitle: "Messages Report",
	pageSubtitle: "Track volume, cost and origins of SMS dispatches in the organization.",
	filters: {
		dateRange: "Period",
		origin: "Origin",
		place: "Place",
		event: "Event",
		allOrigins: "Filter by origin",
		allPlaces: "Filter by Place",
		placesLabel: "Place",
		originsLabel: "Origin",
		allEvents: "Filter by Event",
	},
	cards: {
		totalSent: "Total Sent",
		activePlaces: "Active Places",
		eventsWithMessages: "Events with Messages",
		distinctOrigins: "Distinct Origins",
		vsPreviousPeriod: "vs previous period",
		ofRegistered: "of {{total}} registered",
		distinctOriginsCount: "{{count}} distinct origins",
		deliveryStatus: "Delivery Status",
		delivered: "Delivered",
		failed: "Failed",
		successRate: "Success Rate",
	},
	charts: {
		byOrigin: "SMS by origin",
		byPlace: "SMS by place",
		dailyVolume: "Daily send volume",
		showAll: "Show all ({{count}})",
		showLess: "Show less",
		deliveryStatus: "Delivery status",
		successRate: "Success rate",
	},
	ranking: {
		title: "Top dispatches in period",
	},
	origins: {
		npsForm: "Satisfaction Survey (NPS)",
		giftback: "Giftback",
		campaignMessage: "Message Sending",
		givePromotion: "Promotion",
		digitalCashlessRechargeLowBalanceSms: "Recharge SMS (low balance digital cashless)",
		withdrawRequest: "Withdrawal Request Confirmation",
		pdvPaymentReceipt: "POS Payment Receipt",
		loyaltyProgramCreated: "Loyalty Program",
		coalaIntegration: "Delivery",
		kitchen: "Grab&Go (B2C App)",
	},
	originCategories: {
		npsForm: "NPS",
		giftback: "Cashback",
		campaignMessage: "Campaign",
		givePromotion: "Promotion",
		digitalCashlessRechargeLowBalanceSms: "Recharge",
		withdrawRequest: "Financial",
		pdvPaymentReceipt: "POS",
		loyaltyProgramCreated: "Loyalty",
		coalaIntegration: "Integration",
		kitchen: "Integration",
	},
	tabs: {
		charts: "Charts",
		list: "List",
	},
	table: {
		date: "Date",
		place: "Place",
		event: "Event",
		origin: "Origin",
		smsCount: "SMS Sent",
		deliveredCount: "Delivered",
		failedCount: "Failed",
		successRate: "Success Rate",
		total: "Total",
		resultsPerPage: "Results per page",
	},
	noData: "No data for the selected period",
};
